import React, { useEffect, useState } from 'react'
import {  X  } from "@phosphor-icons/react";
// import axios from 'axios';
import axiosInstance from '../../api/axiosInstance.js';
import { toast } from 'react-toastify';
import PageLoader from '../loader/PageLoader.js';


export default function CheckOutModal(props) {
    
    const hotelId = localStorage.getItem("hotelId");
    const [isLoading,setIsLoading] = useState(false);

    const closeModal = ()=>{
        props.setCheckOutModal(false);
    }

    useEffect(()=>{
        if(props.checkOutRoom){
            console.log("Modal Check Out Room : ",props.checkOutRoom);
        }
        else{
            props.setCheckOutRoom(false);
        }
    },[]);

    const checkOutRoom = async()=>{
        try{
            setIsLoading(true);
            // console.log("CheckOut Modal Room : ",props.checkOutRoom);
            const bookinId  = props.checkOutRoom.booking_id
            const bookedRoomId = props.checkOutRoom.booked_room_id

            const response1 = await axiosInstance.get(`/api/v1/hotels/${hotelId}/bookings/${bookinId}/booked-rooms/${bookedRoomId}`);
            // console.log("Room Data : ",response1.data);

            const data = response1.data;

            const response3 = await axiosInstance.get(`/api/v1/users`);
            const usersData = response3?.data?.data || [];
            const enrichedGuests = (data?.guests || []).map(guest => {
            const matchedUser = usersData.find(user => user.contact === guest.contact);
                if (matchedUser) {
                    return {
                        ...guest,
                        user_id: matchedUser.id
                    };
                }
                return guest; // Return as-is if no match
            });

            const FinalSubmit = {
                number_of_guests : data?.guests?.length || 0,
                checkin_date: data?.checkin_date || "",
                checkout_date: data?.checkout_date || "",
                room_number: data?.room_number,
                guest_details: enrichedGuests,
                payment_status : "SUCCESSFUL"
            };

            
            if ((data.checkin_date === "" || data.checkin_date == null) || (data.checkout_date === "" || data.checkout_date == null) || !data.room_number) {
                toast.error("Check In Date or Check out Date or Room Number is Missing Please Update....");
                return;
            }
        

           
            // console.log("Final Submit Data : ",FinalSubmit);
            // return
            const response = await axiosInstance.put(
                `/api/v1/hotels/${hotelId}/bookings/${bookinId}/booked-rooms/${bookedRoomId}`,FinalSubmit
            );
            toast.success(`Room Number ${props?.checkOutRoom?.room_no || ""} Checkout Successfully`)
            props.setCheckOutModal(false);
            props.setSelectedBookedRoom(null);
        }catch(error){
            toast.error("Some Error Occured");
            console.log(error);
        }
        finally{
            setIsLoading(false);
        }
    }


  return (
    <>
        {
            isLoading && <PageLoader/>
        }
        <div className="fixed top-0 left-0 h-screen w-screen bg-black bg-opacity-60 flex items-center justify-center z-[45]">
            <div className="pastBookingCard bg-white w-1/2 overflow-y-auto rounded-md" style={{ height: "fit-content" }}>

                {/* Check Out Room Header */}
                <div className="py-2 flex justify-between items-center p-2 border-b border-[#BFC4CC]">
                    <h2 className="text-2xl text-[#262B33] tracking-[6px]">
                        CHECKOUT ROOM   {props?.checkOutRoom?.room_no || ""}
                    </h2>
                    <span className="bg-[#EEF0FB] p-2 rounded-md border-md cursor-pointer" onClick={()=>{closeModal()}}>
                        <X className="text-[#343330]" />
                    </span>
                </div>

                {/* CheckOut Room Content */}
                <div className="p-8">
                    <div className="text-center">
                        <h4 className='text-xl'>
                            Are You Sure You Want to Check Out This Room ?
                        </h4>
                    </div>
                    <div className='flex gap-4 mt-10'>
                        <button className='w-full p-2 bg-[#FF7378] rounded-md' onClick={()=>checkOutRoom()}>Yes</button>
                        <button className='w-full p-2 bg-[#0B22B2] rounded-md text-white' onClick={()=>closeModal()}>No</button>
                    </div>
                </div>
            </div>
        </div>
    </>
  )
}
